<span
  class="flex h-5 w-fit shrink-0 items-center justify-center rounded-lg border border-feedback-success-medium bg-feedback-success-medium px-2 py-1 text-xs/loose font-medium text-neutral-hight-pure"
  [class.ml-2]="variant() === 'sidebar'"
  [class.ml-auto]="variant() === 'dropdown'"
>
  {{ 'new_tag.tag' | translate }}
</span>
